import { FC } from 'react';
import SuperUpload from '../SuperUpload';
import SimpleFormItem from './subpage/simpleFormItem';
import { BaseSimpleFormProps, SimpleFormItemEnum } from './interface';
import { UploadImagesProps } from '../SuperUpload/uploadImages';

export interface SimpleFormUploadImagesProps extends BaseSimpleFormProps {
  uploadImagesProps?: UploadImagesProps;
}
const simpleFormUploadImages: FC<SimpleFormUploadImagesProps> = props => {
  const { uploadImagesProps, ...restProps } = props;
  const normFile = (e: any) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };
  return (
    <SimpleFormItem
      valuePropName="fileList"
      getValueFromEvent={normFile}
      {...restProps}
    >
      <SuperUpload.Images {...uploadImagesProps} />
    </SimpleFormItem>
  );
};

simpleFormUploadImages.displayName = SimpleFormItemEnum.SimpleFormUploadImages;

export default simpleFormUploadImages;
